import { Component, inject } from '@angular/core';
import { DefaultLayoutComponent } from '@nimmsta/ng-commons-lib/default-layout';
import { DefaultMenuComponent } from '@nimmsta/ng-commons-lib/menu';
import { Version } from '@nimmsta/ng-commons-lib/models';
import { VersionService } from '@nimmsta/ng-commons-lib/services/version';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { VERSION } from '../../environments/version';
import { environment } from '../../environments/environment';

_('dashboard.nav');
_('worker.nav');
_('dataconnection.nav');
_('dataconnection.template.nav');
_('workflow.nav');
_('workflow.default.nav');
_('user.nav');
_('device.nav');
_('software.nav');
_('support.nav');
_('job.nav');
_('admin.nav');

@Component({
  templateUrl: './layout.component.html',
  imports: [DefaultLayoutComponent, DefaultMenuComponent],
})
export class LayoutComponent {
  private versionService = inject(VersionService);

  protected _sidebarCollapsed = false;

  protected _mobileNavExpanded = false;

  frontendVersion?: Version = VERSION;

  backendVersion?: Version;

  constructor() {
    this.versionService.setBaseURL(`${environment.apiUrls.workflow}/api/v1`);
    this.versionService.getBackendVersion().subscribe((version) => {
      this.backendVersion = version;
    });
  }

  updateMobileNavExpanded(expanded: boolean) {
    this._mobileNavExpanded = expanded;
  }

  updateSidebarCollapsed(collapsed: boolean) {
    this._sidebarCollapsed = collapsed;
  }
}
